// SetPassword.js (JavaScript) - Version: v1 i8

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "./BackButton";
import "./Login.css"; // Einheitliches Styling für alle Auth-Seiten

export default function SetPassword() {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [message, setMessage] = useState("");
    const [token, setToken] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const logo = "/logo192.png"; // Logo aus /public/-Ordner laden

    useEffect(() => {
        // Token aus URL extrahieren
        const params = new URLSearchParams(window.location.search);
        const tokenFromUrl = params.get("token");

        console.log("📌 Token aus URL:", tokenFromUrl); // <-- DEBUGAUSGABE

        if (!tokenFromUrl) {
            setMessage("❌ Ungültiger oder fehlender Token.");
            setIsLoading(false);
        } else {
            setToken(tokenFromUrl);
            setIsLoading(false);
        }
    }, []);

    const handleSetPassword = async (e) => {
        e.preventDefault();
        setMessage("");

        if (password.length < 6) {
            setMessage("❌ Das Passwort muss mindestens 6 Zeichen lang sein.");
            return;
        }
        if (password !== confirmPassword) {
            setMessage("❌ Die Passwörter stimmen nicht überein.");
            return;
        }

        console.log("📌 Sende Token und Passwort:", JSON.stringify({ token, password }, null, 2)); // <-- DEBUGAUSGABE

        try {
            const response = await fetch("https://freiseinapp.de/api/set_password.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ token, password }),
            });

            const data = await response.json();
            console.log("📌 API-Antwort:", JSON.stringify(data, null, 2)); // <-- DEBUGAUSGABE

            if (data.success) {
                setMessage("✅ Passwort erfolgreich gesetzt. Du kannst dich jetzt einloggen.");
                setTimeout(() => navigate("/login"), 3000);
            } else {
                setMessage(data.message || "❌ Fehler beim Speichern des Passworts.");
            }
        } catch (error) {
            console.error("❌ Netzwerkfehler:", error);
            setMessage("❌ Netzwerkfehler. Bitte versuche es später erneut.");
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <img src={logo} alt="FreiSeinApp Logo" className="login-logo" />
                <h2>🔑 Neues Passwort setzen</h2>
                {isLoading ? (
                    <p>⏳ Lade...</p>
                ) : (
                    token ? (
                        <form onSubmit={handleSetPassword}>
                            <input
                                type="password"
                                placeholder="Neues Passwort"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <input
                                type="password"
                                placeholder="Passwort bestätigen"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                            />
                            <button type="submit">Passwort speichern</button>
                        </form>
                    ) : (
                        <p className="login-message">{message}</p>
                    )
                )}
                {message && <p className="login-message">{message}</p>}
                
                <BackButton />
            </div>
        </div>
    );
}
